export default __webpack_public_path__ + "static/media/map.e141b8f3.png";